var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL SERVICES","title":"Subscription","description":"Review portal and SMS subscription plans, balances and details.","count-label":"subscription options"}},[_c('Submenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }